module.exports = __webpack_public_path__ + "img/afeo-logo.fdb45f4a.png";